import { useComputed } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

const CreateConfigTemplateModal = ({ showSignal, configTemplateListSignal, newConfigTemplateNameSignal, handleSubmit }) => {

    const configTemplateNamesComputed = useComputed(() => {
        if (configTemplateListSignal.value) {
            return configTemplateListSignal.value.map((p) => p.name)
        }
        return []
    })

    const nameAlreadyUsedComputed = useComputed(() => {
        return configTemplateNamesComputed.value.length && configTemplateNamesComputed.value.includes(newConfigTemplateNameSignal.value)
    })

    const disableSubmitComputed = useComputed(() => {
        return (newConfigTemplateNameSignal.value?.length == 0 || nameAlreadyUsedComputed.value)
    })

    return (
        <Modal show={showSignal.value} onHide={() => showSignal.value = false}>
            <Modal.Header closeButton>
                <Modal.Title>New Config Template</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Config Template Name</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onInput={(e) => newConfigTemplateNameSignal.value = e.target.value}
                            autoFocus
                            value={newConfigTemplateNameSignal.value}
                        />
                        <p className="mt-1" hidden={!nameAlreadyUsedComputed.value}>Config template name must be unique</p>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => showSignal.value = false}>
                    Cancel
                </Button>
                <Button disabled={disableSubmitComputed.value} variant="primary" onClick={handleSubmit}>
                    Add New
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default CreateConfigTemplateModal